<template>
  <div id="contact-me-modal">
    <section>
      <div class="container">
        <div class="contact-me-modal__heading text--align-left">
          <h1>LET'S CONNECT</h1>
        </div>
        <div class="flex flex-space-between">
          <div class="contact-me-modal__left text--align-left flex flex-column">
            <h3 class="text--grey">MAIL</h3>
            <h3
              class="contact-me-modal__email-detail"
              @mouseenter="gExpandCursor"
              @mouseleave="gShrinkCursor"
            >
              YONGTING1998@GMAIL.COM
            </h3>
          </div>
          <div class="contact-me-modal__right flex flex-column">
            <h3 class="text--grey">SOCIALS</h3>
            <h3
              class="contact-me-modal__email-detail"
              @mouseenter="gExpandCursor"
              @mouseleave="gShrinkCursor"
              @click="openLinkedIn"
            >
              LinkedIn
            </h3>
          </div>
        </div>
        <button class="close-button" @click="closeContactMe">Close</button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  methods: {
    closeContactMe() {
      document.getElementById("contact-me-modal").classList.add("close");
      setTimeout(() => {
        document.getElementById("contact-me-modal").classList.remove("close");
        this.$emit("close");
      }, 1000);
    },
    openLinkedIn() {
      window.open("https://www.linkedin.com/in/lim-yong-ting/", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
#contact-me-modal {
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 2;
  left: 0;
  top: 0;
  background-color: #161616;
  animation: fadeIn 500ms ease-in;
  -webkit-animation: fadeIn 500ms ease-in;
  -moz-animation: fadeIn 500ms ease-in;
  -o-animation: fadeIn 500ms ease-in;
  z-index: 11;
  &.close {
    opacity: 0;
    animation: fadeOut 500ms ease-in;
  }
}
.contact-me-modal__left,
.contact-me-modal__right {
  animation: fadeInWait 2s linear;
  -webkit-animation: fadeInWait 2s linear;
  -moz-animation: fadeInWait 2s linear;
  -o-animation: fadeInWait 2s linear;
  h3 {
    display: inline-block;
  }
}
.contact-me-modal__left {
  margin-right: 30px;
}
.contact-me-modal__right {
  margin-left: 30px;
}
@media only screen and (max-width: 768px) {
  .contact-me-modal__left,
  .contact-me-modal__right {
    font-size: 0.8rem;
  }
  .contact-me-modal__left {
    margin-right: 5px;
  }
  .contact-me-modal__right {
    margin-left: 5px;
  }
}

.contact-me-modal__heading {
  h1 {
    animation: dropDown 2s linear;
  }
  &::after {
    display: block;
    content: "";
    border-bottom: solid 1px #e6e6e6;
    transform-origin: left center;
    transition: transform 300ms ease-in-out;
    padding-top: 5px;
    animation: scaleInLeft 2s linear;
    -webkit-animation: scaleInLeft 2s linear;
    -moz-animation: scaleInLeft 2s linear;
    -o-animation: scaleInLeft 2s linear;
    transform: scaleX(1);
  }
  padding-bottom: 10px;
}
.contact-me-modal__email-detail {
  &::after {
    display: block;
    content: "";
    border-bottom: solid 1px #e6e6e6;
    transform: scaleX(0);
    transform-origin: left center;
    transition: transform 300ms ease-in-out;
    padding-top: 5px;
  }
  &:hover {
    &::after {
      transform: scaleX(1);
    }
  }
}
.close-button {
  background: none;
  border: 0;
  box-sizing: border-box;
  color: transparent;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 1.5px;
  outline: none;
  overflow: hidden;
  padding: 2px 0 0;
  position: absolute;
  text-transform: uppercase;
  top: 100px;
  right: 50px;
  transform: translate(-50%, -50%);
  transition: all 0.2s ease-in;
  width: 50px;
  line-height: 50px;
  @media only screen and (max-width: 768px) {
    transform: scale(0.7);
    top:50px;
  }
}

.close-button::before,
.close-button::after {
  background-color: #e6e6e6;
  content: "";
  display: block;
  height: 3px;
  left: 0;
  position: absolute;
  transform-origin: center left;
  transition: all 0.2s ease-in;
  width: 80px;
  z-index: -1;
}

.close-button::before {
  top: 0;
  transform: rotate(45deg);
}

.close-button::after {
  bottom: 0;
  transform: rotate(-45deg);
}

.close-button:hover {
  color: #8a2387;
}

.close-button:hover::before,
.close-button:hover::after {
  height: 50px;
  transform: rotate(0deg);
}

@keyframes scaleInLeft {
  0%,
  50% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}
@keyframes dropDown {
  0% {
    transform: translateY(-100%);
    transform: rotate(20deg);
  }
  20% {
    transform: rotate(0deg);
  }
  100% {
    transform: translateX(0%);
  }
}
@keyframes fadeInWait {
  0%,
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
